import { CustomNavHelper } from '@unifyapps/carbon/helpers/CustomNavHelper';
import { InterfaceNavigationHelper } from '@unifyapps/carbon/helpers/InterfaceNavigationHelper';
import { checkIfNavigationEmpty } from '@unifyapps/carbon/no-code/utils/checkIfNavigationEmpty';
import {
  ApplicationType,
  type InterfaceEntity,
  type NavigationResolution,
} from '@unifyapps/defs/types/interface';
import { CustomNav } from './CustomNav';
import { DrawerNav } from './DrawerNav';
import { SideOrBottomNav } from './SideOrBottomNav';

export default function AppNavigation({
  interfaceRecord,
  resolution,
}: {
  interfaceRecord: InterfaceEntity;
  resolution: NavigationResolution;
}) {
  const isNavigationEmpty = checkIfNavigationEmpty({ interfaceRecord, resolution });

  const showSideOrBottomNav = InterfaceNavigationHelper.showSideOrBottomNav(
    interfaceRecord,
    resolution,
  );

  const showDrawerNav = InterfaceNavigationHelper.showDrawerNav(interfaceRecord, resolution);

  const isCustomWebNavEnabled = CustomNavHelper.isEnabled(
    interfaceRecord,
    resolution,
    ApplicationType.WEB,
    true,
  );

  const customNavModuleId = CustomNavHelper.getModuleId(interfaceRecord, resolution);
  const shouldShowCustomNav =
    showSideOrBottomNav && isCustomWebNavEnabled && Boolean(customNavModuleId);

  return (
    <>
      {shouldShowCustomNav ? (
        <SideOrBottomNav interfaceRecord={interfaceRecord} resolution={resolution}>
          <CustomNav interfaceRecordId={interfaceRecord.id} moduleId={customNavModuleId ?? ''} />
        </SideOrBottomNav>
      ) : null}
      {!isNavigationEmpty && showSideOrBottomNav && !shouldShowCustomNav ? (
        <SideOrBottomNav interfaceRecord={interfaceRecord} resolution={resolution} />
      ) : null}
      {!isNavigationEmpty && showDrawerNav ? (
        <DrawerNav interfaceRecord={interfaceRecord} resolution={resolution} />
      ) : null}
    </>
  );
}
